export class CMSResource {
    
    errorCode: number;

	 errorMessage: string;
}
